export enum AdditionalFilterKeyEnum {
    GROUPS_INCLUDE_DELETED_GROUPS,
    GROUPS_EXCLUDE_VERIFIED_PRICE_GROUPS,
}
